// Init.ts
// -------
// Self calling function which procedurally checks for compatibility and sets browser up before initializing the app
// Return value: Boolean; Allows the child code to conditionally start app based on result
import {environment} from '../environments/environment';

export class Init {

  makeRegionalApiUrl(region) {
    if (region != 'au') {
      const originalUrl = environment.API;
      const api = originalUrl.slice(0, originalUrl.indexOf('.'));
      const domain = originalUrl.slice(originalUrl.indexOf('.') + 1);

      return `${api}-${region}.${domain}`;

    } else {
      return environment.API;
    }
  }

}
